import { createI18n } from 'vue-i18n'
import { App } from 'vue'

export const defaultLanguage = 'en'

export const languages = [
  { label: 'English', value: 'en' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Español', value: 'es' },
  { label: 'Français', value: 'fr' },
  { label: 'Italiano', value: 'it' },
  { label: 'Polski', value: 'pl' },
  { label: 'Pусский', value: 'ru' },
  { label: 'Português', value: 'pt' },
]

const i18n = createI18n({
  locale: defaultLanguage, // set locale
  fallbackLocale: defaultLanguage, // set fallback locale
  messages: {},
})

function registerI18nPlugin(app: App) {
  app.use(i18n)
}

export { i18n, registerI18nPlugin }
